import {
  TextField,
  Box,
  IconButton,
  useTheme,
  MenuItem,
  Typography,
  Menu,
  Tooltip,
  Chip,
  LinearProgress,
  Checkbox,
  FormControlLabel,
  Button,
  Stack,
} from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RedoIcon from "@mui/icons-material/Redo";
import UndoIcon from "@mui/icons-material/Undo";
import BlockIcon from "@mui/icons-material/Block";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import LockResetIcon from "@mui/icons-material/LockReset";
import EscalatorWarningIcon from "@mui/icons-material/EscalatorWarning";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
// import MatxCustomizer from "./Mailpdf";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import BalanceIcon from "@mui/icons-material/Balance";
import ViewInArOutlinedIcon from "@mui/icons-material/ViewInArOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { tokens, ColorModeContext } from "../../Theme";
import { useProSidebar } from "react-pro-sidebar";
import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import {
  AssessmentCheck,
  fetchListview,
  SessionCheck,
} from "../../store/reducers/Listviewapireducer";
import useMediaQuery from "@mui/material/useMediaQuery";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { Link } from "react-router-dom";
import { useContext } from "react";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { useState } from "react";
import { fnCsvFileUpload } from "../../store/reducers/Imguploadreducer";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { screenRightsData } from "../../store/reducers/screenRightsreducer";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import WysiwygIcon from "@mui/icons-material/Wysiwyg";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
import PauseCircleOutlinedIcon from "@mui/icons-material/PauseCircleOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import NotStartedOutlinedIcon from "@mui/icons-material/NotStartedOutlined";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import EmailIcon from "@mui/icons-material/Email";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../ui-components/global/utils";
import { fetchExplorelitview } from "../../store/reducers/Explorelitviewapireducer";
import { Employeeautocomplete } from "../../ui-components/global/Autocomplete";
import FlagIcon from "@mui/icons-material/Flag";
import AddTaskIcon from "@mui/icons-material/AddTask";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import TodayIcon from "@mui/icons-material/Today";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import axios from "axios";
import { AttachFile } from "@mui/icons-material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Swal from "sweetalert2";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { AppraisalGet } from "../../store/reducers/Formapireducer";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import QuizIcon from "@mui/icons-material/Quiz";

const AppraisalListView = () => {
  const navigate = useNavigate();
  const colorMode = useContext(ColorModeContext);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const YearFlag = sessionStorage.getItem("YearFlag");
  var currentPage = parseInt(sessionStorage.getItem("currentPage"));
  const location = useLocation();
  const dispatch = useDispatch();
  const params = useParams();
  console.log("-----------------------", params);

  var accessID = params.accessID;
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const [pageSize, setPageSize] = React.useState(20);
  const [page, setPage] = React.useState(currentPage || 0);
  const [collapse, setcollapse] = React.useState(false);
  var invoice;
  const mailData = useSelector((state) => state.listviewApi.mailData);
  const EmployeeID = sessionStorage.getItem("EmpId");
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const open = useSelector((state) => state.listviewApi.mailOpen);
  var screenName = params.screenName;
  // console.log("🚀 ~ file: Listview.jsx:54 ~ Listview ~ screenName", screenName);
  const year = sessionStorage.getItem("year");
  const listViewData = useSelector((state) => state.listviewApi.rowData);

  const loading = useSelector(
    (state) => state.formApi.SkilGlowAppraisalGetLoading
  );
  const rowData = useSelector(
    (state) => state.formApi.SkilGlowAppraisalGetData
  );

  const AppraisalListViewGet = useSelector(
    (state) => state.globalurl.AppraisalListView
  );

  const { UGA_ADD, UGA_VIEW, UGA_MOD, UGA_DEL, UGA_PROCESS, UGA_PRINT } =
    useSelector((state) => state.screenRights.data);

  const formatDateTime = (date) => {
    const pad = (n) => n.toString().padStart(2, "0");
    return (
      `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )} ` +
      `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds()
      )}`
    );
  };

  useEffect(() => {
    if (EmployeeID) {
      const payload = { data: { EmployeeID: EmployeeID } };
      dispatch(AppraisalGet(payload));
    }
  }, [dispatch, EmployeeID]);

  const listViewcolumn = useSelector((state) => state.listviewApi.columnData);

  const compID = sessionStorage.getItem("compID");
  const EmpId = sessionStorage.getItem("EmpId");
  const companyID = sessionStorage.getItem("companyId");

  const [selectedDate, setSelectedDate] = useState("");

  function filterByID(item) {
    if (item.hide !== true) {
      return true;
    }
  }

  const columnShow = React.useMemo(
    () => listViewcolumn.filter(filterByID),
    [listViewcolumn]
  );

  const handlePagechange = (pageno) => {
    setPage(pageno);
    sessionStorage.setItem("currentPage", pageno);
  };
  const isExamCompleted = (skill) => {
    const data = JSON.parse(
      localStorage.getItem(`skill_answers_${skill}`) || "{}"
    );

    const answeredCount = Object.keys(data).length;
    return answeredCount === 5;
  };
  const ToAssessment = (skill) => {
    const saved = localStorage.getItem(`skill_answers_${skill}`);

    if (saved) {
      const data = JSON.parse(saved);

      const questions = [
        { id: "q1", type: "mcq" },
        { id: "q2", type: "boolean" },
        { id: "q3", type: "rating" },
        { id: "q4", type: "text" },
        { id: "q5", type: "text" },
      ];

      const allAnswered = questions.every((q) => {
        const ans = data[q.id];
        if (q.type === "mcq") return Array.isArray(ans) && ans.length > 0;
        if (q.type === "rating") return typeof ans === "number" && ans > 0;
        return ans !== undefined && ans !== "";
      });

      if (allAnswered) {
        navigate("/Apps/skillglow/listpage/SkillGlow/SkillResultDashboard");
      } else {
        // Incomplete answers → go to exam
        navigate("/Apps/skillglow/listpage/SkillGlow/SkillExam", {
          state: { skill },
        });
      }
    } else {
      // No saved answers → start fresh exam
      navigate("/Apps/skillglow/listpage/SkillGlow/SkillExam", {
        state: { skill },
      });
    }
  };

  const ToSession = () => {
    navigate("/Apps/skillglow/listpage/SkillGlow/SkillReview");
  };
  const ToShowCase = () => {
    navigate("/Apps/skillglow/listpage/SkillGlow/SkillGlowShowCase");
  };
  
  const state = location.state || {};

  const FnAssessmentCheck = async (row) => {
    const data = await dispatch(
      AssessmentCheck({
        data: {
          EmpassscheduledRecordID: row.RecordID,
          EmployeeID: row.EmployeeID,
        },
      })
    );

    if (data.payload.Status == "Y") {
      navigate(`./Edit${screenName}/${row.AssessmentID}/${row.RecordID}/A`, {
        state: {
          ...state,
          BreadCrumb1: row.AssessmentName,
          BreadCrumb2: row.QuestionGroupName,
        },
      });
    } else {
      Swal.fire({
        title: "Assessment Not Available",
        text: data.payload.Msg,
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6",
      });
      //toast.error(data.payload.Msg);
    }

    // if(data.payload.)
  };

  const columns = [
    { field: "id", headerName: "SL#", width: 50 },
    {
      field: "AssessmentName",
      headerName: "Assessment",
      width: 250,
      editable: true,
      headerAlign: "center",
    },
    {
      field: "date",
      headerName: "Date",
      width: 150,
      editable: true,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "targetDate",
      headerName: "Target Date",
      width: 150,
      editable: true,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "noOfAtt",
      headerName: "No. Of Attempts",
      width: 150,
      editable: true,
      headerAlign: "center",
      align: "right",
    },
    {
      field: "CurrentAttempt",
      headerName: "Current Attempt",
      width: 150,
      editable: true,
      headerAlign: "center",
      align: "right",
    },
    {
      field: "firstAttDate",
      headerName: "First Att Date",
      width: 150,
      editable: true,
      headerAlign: "center",
    },
    {
      field: "firstAttScore",
      headerName: "First Att Score",
      width: 100,
      editable: true,
      headerAlign: "center",
      align: "right",
    },
    {
      field: "lastAttDate",
      headerName: "Last Att Date",
      width: 150,
      editable: true,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "lastAttScore",
      headerName: "Last Att Score",
      width: 100,
      editable: true,
      headerAlign: "center",
      align: "right",
    },

    {
      field: "status",
      headerName: "Status",
      width: 150,
      editable: true,
      headerAlign: "center",
    },
    {
      field: "Actions",
      headerName: "Actions",
      //flex: 1,
      width: 150,
      headerAlign: "center",
      align: "center",

      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="Story Board">
            <IconButton
              color="primary"
              size="small"
              onClick={() =>
                navigate(
                  `/Apps/Secondarylistview/skillglow/TR284/List Of Story Board/${params.row.EmployeeID}/${params.row.AssessmentID}`,
                  {
                    state: { BreadCrumb1: params.row.AssessmentName },
                  }
                )
              }
            >
              <FileUploadOutlinedIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Session">
            <IconButton
              color="primary"
              size="small"
              // onClick={() => FnSessionCheck(params.row) }
              onClick={() => {
                dispatch(
                  SessionCheck({
                    data: {
                      AssessmentID: params.row.AssessmentID,
                      EmployeeID: EmployeeID,
                    },
                  })
                );
                navigate(
                  `/Apps/Secondarylistview/skillglow/TR289/List Of Session/${params.row.AssessmentID}`,
                  {
                    state: { BreadCrumb1: params.row.AssessmentName },
                  }
                );
              }}
            >
              <AccessTimeIcon />
            </IconButton>
          </Tooltip>

          {/* HIDE AND SHOW OF ICONS IN ASSESSMENT */}
          <Tooltip
            title={
              params.row.Status === "Pass"
                ? "View Scoreboard"
                : "Start Assessment"
            }
          >
            {params.row.Status === "Pass" ? (
              <IconButton
                color="secondary"
                size="small"
                onClick={() =>
                  navigate(
                    "/Apps/skillglow/listpage/SkillGlow/SkillResultDashboard",
                    {
                      state: {
                        AssessmentName: params.row.AssessmentName,
                        AssessmentID: params.row.AssessmentID,
                        Lastattdate: params.row.Lastattdate,
                        Firstattdate: params.row.Firstattdate,
                        Lastattscore: params.row.Lastattscore,
                        NoofAttemp: params.row.NoofAttemp,
                        EmployeeName: params.row.EmpName,
                      },
                    }
                  )
                }
              >
                {/* <DashboardIcon /> */}
                <AnalyticsIcon />
              </IconButton>
            ) : (
              <IconButton
                color="error"
                size="small"
                onClick={() => FnAssessmentCheck(params.row)}
              >
                {/* <AssessmentIcon /> */}
                <QuizIcon />
              </IconButton>
            )}
          </Tooltip>
        </>
      ),
    },
  ];
  //   const rows = [
  //     { id: 1,
  //       Skill: "React JS - Front End",
  //       date:"25-08-2025",
  //       targetDate:"27-08-2025",
  //       firstAttDate:"25-08-2025" ,
  //       firstAttScore:5,
  //       lastAttDate:"27-08-2025" ,
  //       lastAttScore:6,
  //       noOfAtt:2,
  //       status:"Not Attended"

  //     },
  //     { id: 2,
  //       Skill: "React JS - Back End",
  //       date:"25-08-2025",
  //       targetDate:"27-08-2025",
  //       firstAttDate:"25-08-2025" ,
  //       firstAttScore:5,
  //       lastAttDate:"27-08-2025" ,
  //       lastAttScore:6,
  //       noOfAtt:2,
  //       status:"Not Attended"

  //     },
  //     { id: 3,
  //       Skill: "React Native",
  //       date:"25-08-2025",
  //       targetDate:"27-08-2025",
  //       firstAttDate:"25-08-2025" ,
  //       firstAttScore:5,
  //       lastAttDate:"27-08-2025" ,
  //       lastAttScore:6,
  //       noOfAtt:2,
  //       status:"Not Attended"

  //     },
  //     { id: 4,
  //       Skill: "Laravel",
  //       date:"25-08-2025",
  //       targetDate:"27-08-2025",
  //       firstAttDate:"25-08-2025" ,
  //       firstAttScore:5,
  //       lastAttDate:"27-08-2025" ,
  //       lastAttScore:6,
  //       noOfAtt:2,
  //       status:"Not Attended"

  //     },
  //     // { id: 2, Skill: "React JS - Back End" },
  //     // { id: 3, Skill: "React Native" },
  //     // { id: 4, Skill: "Laravel" },
  //   ];

const rows =
  rowData?.map((item, index) => ({
    id: index + 1,
    RecordID: item.RecordID,
    AssessmentID: item.AssessmentID,
    EmployeeID: item.EmployeeID,
    ManagerID: item.ManagerID,
    EmpName: item.EmpName,
    AssessmentName: item.AssessmentName,
    date: item.Date,
    targetDate: item.Targeteddate,
    CurrentAttempt: item.CurrentAttempt,
    firstAttDate: item.Firstattdate,
    firstAttScore: item.Firstattscore,
    lastAttDate: item.Lastattdate,
    lastAttScore: item.Lastattscore,
    noOfAtt: item.NoofAttemp,
    status: item.Status,
  })) || [];


  const fnLogOut = (props) => {
    Swal.fire({
      title: `Do you want ${props}?`,
      // text:data.payload.Msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate("/Apps/TR027/Employees");
        }
      } else {
        return;
      }
    });
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        key={location.key}
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        {broken && !rtl && (
          <IconButton
            sx={{ margin: "0 6 0 2" }}
            onClick={() => toggleSidebar()}
          >
            <MenuOutlinedIcon />
          </IconButton>
        )}
        <Box sx={{ display: "flex", flexDirection: "row", gap: 10 }}>
          <Typography variant="h3">List Of Appraisal Assessment</Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />

          {/* <Tooltip arrow title="Add">
            <IconButton>
              <AddOutlinedIcon
                onClick={() =>
                navigate(
                  "/Apps/SkillGlow/SkillGlowList/CandidateList/CreateCandidates"
                )
              }
              />
            </IconButton>
          </Tooltip> */}

          <GridToolbarExport
            printOptions={{ disableToolbarButton: true }}
            csvOptions={{
              fileName: `${screenName}`,
            }}
          />

          <Tooltip arrow title="Logout">
            <IconButton onClick={() => fnLogOut("Logout")} color="error">
              <LogoutOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </GridToolbarContainer>
    );
  }
  return (
    <React.Fragment>
      <Box m="5px">
        <Box
          m="5px 0 0 0"
          padding={2}
          height={dataGridHeight}
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[800],
              // borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[800],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
            "& .odd-row": {
              backgroundColor: "",
              color: "", // Color for odd rows
            },
            "& .even-row": {
              backgroundColor: "#d0edec",
              color: "", // Color for even rows
            },
          }}
        >
          {/* {accessID === "TR123" && (
            <Box sx={{ fontSize: '12px' }}>
              {formatDateTime(new Date())}
            </Box>
          )}
          {accessID === "TR124" && (
            <Box sx={{ fontSize: '12px' }}>
              {formatDateTime(new Date())}
            </Box>
          )} */}

          <DataGrid
            sx={{
              "& .MuiDataGrid-footerContainer": {
                height: dataGridHeaderFooterHeight,
                minHeight: dataGridHeaderFooterHeight,
              },
            }}
            key={accessID}
            rows={rows}
            columns={columns}
            loading={loading}
            disableSelectionOnClick
            getRowId={(row) => row.id}
            rowHeight={dataGridRowHeight}
            headerHeight={dataGridHeaderFooterHeight}
            pageSize={pageSize}
            page={page}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[5, 10, 15, 20]}
            onPageChange={(pageno) => handlePagechange(pageno)}
            components={{
              Toolbar: CustomToolbar,
            }}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "odd-row"
                : "even-row"
            }
          />
        </Box>

        <Box display="flex" flexDirection="row" padding="25px" gap={2}>
          {/* <Chip
            icon={<VisibilityIcon color="primary" />}
            label="Story Board"
            variant="outlined"
          /> */}
          <Chip
            icon={<FileUploadOutlinedIcon color="primary" />}
            label="Story Board"
            variant="outlined"
          />

          <Chip
            icon={<AccessTimeIcon color="primary" />}
            label="Session"
            variant="outlined"
          />
          <Chip
            icon={<AnalyticsIcon color="error" />}
            label="Start Assessment"
            variant="outlined"
          />
          <Chip
            icon={<QuizIcon color="secondary" />}
            label="View Dashboard"
            variant="outlined"
          />
        </Box>
      </Box>
      {/* <MatxCustomizer open={open}screenName={invoice} rowData={mailData} type={""} /> */}
    </React.Fragment>
  );
};
export default AppraisalListView;
